export type CustomerStorePresentationRow = {
  active?: boolean | null;
  ebayStatus?: string | null;
  ordersCount?: number | null;
  ordersSyncedAt?: string | null;
  platform?: string | null;
  storeUrl?: string | null;
};

export function summarizeCustomerStores<T extends CustomerStorePresentationRow>(stores: readonly T[]) {
  const activeStoreRows = stores.filter((store) => store.active !== false);
  const inactiveStoreRows = stores.filter((store) => store.active === false);
  const connectedStores = activeStoreRows.filter(
    (store) => store.ebayStatus === "active" || Boolean(store.storeUrl) || Boolean(store.ordersSyncedAt)
  ).length;
  const totalOrders = activeStoreRows.reduce((sum, store) => sum + Number(store.ordersCount || 0), 0);
  const syncedStores = activeStoreRows.filter((store) => Boolean(store.ordersSyncedAt)).length;
  const connectedIntegrationCounts = activeStoreRows.reduce<Record<string, number>>((counts, store) => {
    const platform = String(store.platform || "").trim().toLowerCase();
    if (platform) counts[platform] = (counts[platform] || 0) + 1;
    return counts;
  }, {});

  return {
    activeStoreRows,
    connectedIntegrationCounts,
    connectedStores,
    inactiveStoreRows,
    syncedStores,
    totalOrders,
  };
}
